"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
const FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
const doNothing_1 = __importDefault(require("@opsbase/lib-general/utils/doNothing"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const react_1 = __importStar(require("react"));
const Text_1 = __importDefault(require("../Text"));
const makeMyClasses = (small, color) => ({
    root: {
        padding: small ? 0 : 8,
        borderRadius: small ? 4 : '50%',
    },
    colorPrimary: {
        '& input': {
            backgroundColor: `white`,
        },
    },
    colorSecondary: {
        color: lib_palette_1.default.GreyBlue.main,
        '& input': {
            backgroundColor: `white`,
        },
        '&.Mui-checked': {
            color: color.main,
        },
        '&:hover': {
            color: lib_palette_1.default.GreyBlue.dark,
            backgroundColor: lib_palette_1.default.GreyBlue.background + '!important',
        },
        '&.Mui-checked:hover': {
            color: color.main,
            backgroundColor: color.background + '!important',
        },
        '&.Mui-disabled': {
            opacity: 0.5,
        },
    },
    partChecked: {
        color: color.main + '!important',
        '&:hover': {
            color: color.main,
            backgroundColor: color.background + '!important',
        },
    },
});
function Checkbox(props) {
    const { disabled = false, checked = false, partChecked = false, color = lib_palette_1.default.positive, onChange = doNothing_1.default, noClickLabel = false, label, small = false, } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses, [small, color]);
    const rootClassName = myCss.root + ' ' + (partChecked ? myCss.partChecked : '');
    const handleClick = (0, react_1.useCallback)(e => {
        e.stopPropagation();
    }, []);
    const handleChange = (0, react_1.useCallback)((e, v) => onChange(v), [onChange]);
    const control = (react_1.default.createElement(Checkbox_1.default, { disabled: disabled, classes: {
            root: rootClassName + ' newStyle',
            colorPrimary: myCss.colorPrimary + ' newStyle',
            colorSecondary: myCss.colorSecondary + ' newStyle',
        }, onClick: handleClick, onChange: handleChange, checked: checked }));
    if (!label)
        return control;
    if (noClickLabel)
        return (react_1.default.createElement(Horizontal_1.default, { centered: true },
            control,
            react_1.default.createElement(Text_1.default, null, label)));
    return react_1.default.createElement(FormControlLabel_1.default, { control: control, label: label });
}
exports.Checkbox = Checkbox;
exports.default = Checkbox;
